import template from './department_growth_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class DepartmentGrowthReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class DepartmentGrowthReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new DepartmentGrowthReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'DepartmentGrowthReportHelp',
	dialog_class: DepartmentGrowthReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/department_growth_report_help',
	provider: 'ps'
};
